import { Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';

import { Button, TextInput, Text, Alert, FlexRow } from '@summer/ui-components';

export const SetPasswordForm = ({
  passwordTitle = 'Enter Password',
  confirmPasswordTitle = 'Confirm Password',
  buttonText = 'Submit Password',
  errorMessage,
  disclaimer,
  handlePasswordChange,
  onSubmit,
  validationSchema,
  initialValues = { password: '', confirmPassword: '' },
  isLoading,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        isSubmitting,
        isValid,
      }) => {
        const handlePChange = e => {
          handleChange(e);
          handlePasswordChange();
        };
        return (
          <Form onSubmit={handleSubmit}>
            <input
              type="password"
              name="dummy-password"
              style={{ display: 'none' }}
            />
            <TextInput
              label={passwordTitle}
              type="password"
              name="password"
              touched={touched.password}
              isSubmitting={isSubmitting}
              error={errors.password}
              value={values.password}
              onChange={handlePChange}
              onBlur={handleBlur}
              autoComplete="new-password"
            />
            <TextInput
              label={confirmPasswordTitle}
              type="password"
              name="confirmPassword"
              touched={touched.confirmPassword}
              isSubmitting={isSubmitting}
              error={errors.confirmPassword}
              value={values.confirmPassword}
              onChange={handlePChange}
              onBlur={handleBlur}
              autoComplete="new-password"
            />
            {errorMessage && (
              <StyledAlert
                theme="warning"
                testId="invalid-code-alert-text"
                dismissable={false}
              >
                {errorMessage}
              </StyledAlert>
            )}
            <SubTextContainer paragraph>{disclaimer}</SubTextContainer>
            <StyledButton
              disabled={!isValid}
              isLoading={isLoading}
              type="submit"
            >
              {buttonText}
            </StyledButton>
          </Form>
        );
      }}
    </Formik>
  );
};

const Form = styled(FlexRow.withComponent('form'))`
  flex-wrap: wrap;
`;

const SubTextContainer = styled(Text)`
  width: 100%;
  max-width: 600px;
  margin-bottom: 16px;
`;

const StyledButton = styled(Button)`
  width: 100%;
  max-width: 600px;
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;
